// extracted by mini-css-extract-plugin
export default {"emoji_container":"EmojiInput_emoji_container__H1ERt","emoji_dialog":"EmojiInput_emoji_dialog__DwsQb","emoji_btn":"EmojiInput_emoji_btn__IIMaK"};